import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { AdminSessionProvider } from '@/contexts/AdminSessionContext';
import { Loader2 } from 'lucide-react';

export const AdminLayout = () => {
  return (
    <AdminSessionProvider>
      <Suspense fallback={<AdminLoadingFallback />}>
        <Outlet />
      </Suspense>
    </AdminSessionProvider>
  );
};

const AdminLoadingFallback = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center space-y-4">
        <Loader2 className="h-8 w-8 animate-spin text-primary mx-auto" />
        <p className="text-gray-600">Loading admin dashboard...</p>
      </div>
    </div>
  );
};
